export const CLAIMS_GRID_MESSAGES = {
    exportToExcelSuccessfully: `{fileName} is successfully exported.`,
    exportToExcelSystemErrorsMessage: `Export failed due to an unexpected error. Please try again.`,
    exportToExcelPleaseWait: `Please wait, export in progress.`,
};

export const FILE_EXTENSION = {
    xlsx: '.xlsx'
};

export const FILENAME_FORMAT = {
    exportToExcelDefaultFileName: 'claimmanagement-{timestamp}',
    exportToExcelSheetName: 'claimmanagement'
};
